import axios, { AxiosResponse, AxiosError } from 'axios';
import { CachedFileUploadRequest } from '../state/editorTypes';

const uploadFile = async (data: CachedFileUploadRequest) => {
  await axios({
    url: 'report/fileupload',
    method: 'POST',
    data
  });
};

export default uploadFile;
